import { Now, tryParsePlainDate } from "../temporal";
import React, { useEffect } from "react";
import { Box, Grid, MenuItem, TextField } from "@mui/material";
import { PlainDatePicker } from "./PlainDatePicker";
export var TimeFrameType;
(function (TimeFrameType) {
    TimeFrameType["All"] = "All";
    TimeFrameType["Today"] = "Today";
    TimeFrameType["Yesterday"] = "Yesterday";
    TimeFrameType["Last7Days"] = "Last7Days";
    TimeFrameType["LastWeek"] = "LastWeek";
    TimeFrameType["ThisMonth"] = "ThisMonth";
    TimeFrameType["LastMonth"] = "LastMonth";
    TimeFrameType["Last3Months"] = "Last3Months";
    TimeFrameType["LastYear"] = "LastYear";
    TimeFrameType["Custom"] = "Custom";
})(TimeFrameType || (TimeFrameType = {}));
export function TimeframePicker({ value, onChange, i18n }) {
    var _a, _b;
    const { type, from, until } = value;
    const fromPlainDate = (_a = tryParsePlainDate(from)) !== null && _a !== void 0 ? _a : null;
    const untilPlainDate = (_b = tryParsePlainDate(until)) !== null && _b !== void 0 ? _b : null;
    useEffect(() => {
        const { from, until } = computeFromUntil(type, fromPlainDate, untilPlainDate);
        onChange({
            type,
            from: from === null || from === void 0 ? void 0 : from.toString(),
            until: until === null || until === void 0 ? void 0 : until.toString(),
        });
    }, [type, from, until]);
    function handleTypeChange(event) {
        const type = event.target.value;
        const { from, until } = computeFromUntil(type, fromPlainDate, untilPlainDate);
        onChange({
            type,
            from: from === null || from === void 0 ? void 0 : from.toString(),
            until: until === null || until === void 0 ? void 0 : until.toString(),
        });
    }
    function handleFromChange(value) {
        onChange({
            type,
            from: value === null || value === void 0 ? void 0 : value.toString(),
            until,
        });
    }
    function handleUntilChange(value) {
        onChange({
            type,
            from,
            until: value === null || value === void 0 ? void 0 : value.toString(),
        });
    }
    const { timeframeTitle: tTimeframeTitle, from: tFrom, until: tUntil, types: tTypes = {} } = i18n !== null && i18n !== void 0 ? i18n : {};
    return (React.createElement(Box, null,
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, md: 4, xs: 12 },
                React.createElement(TextField, { fullWidth: true, select: true, variant: "outlined", label: tTimeframeTitle !== null && tTimeframeTitle !== void 0 ? tTimeframeTitle : 'Timeframe', value: type, onChange: handleTypeChange }, Object.values(TimeFrameType).map(tf => {
                    var _a;
                    return (React.createElement(MenuItem, { key: tf, value: tf }, (_a = tTypes[tf]) !== null && _a !== void 0 ? _a : tf));
                }))),
            React.createElement(Grid, { item: true, md: 4, xs: 12 },
                React.createElement(PlainDatePicker, { label: tFrom !== null && tFrom !== void 0 ? tFrom : 'From', value: fromPlainDate, onChange: handleFromChange, disabled: type != TimeFrameType.Custom, fullWidth: true })),
            React.createElement(Grid, { item: true, md: 4, xs: 12 },
                React.createElement(PlainDatePicker, { label: tUntil !== null && tUntil !== void 0 ? tUntil : 'Until', value: untilPlainDate, onChange: handleUntilChange, disabled: type != TimeFrameType.Custom, fullWidth: true })))));
}
export function computeFromUntil(type, from, until) {
    const today = Now.plainDateISO();
    const yesterday = today.subtract({ days: 1 });
    const lastMonth = today.subtract({ months: 1 });
    const lastWeek = today.subtract({ weeks: 1 });
    const lastYear = today.subtract({ years: 1 });
    switch (type) {
        case TimeFrameType.All:
            return { from: undefined, until: undefined };
        case TimeFrameType.Custom:
            return { from, until };
        case TimeFrameType.Today:
            return {
                from: today,
                until: today,
            };
        case TimeFrameType.Yesterday:
            return {
                from: yesterday,
                until: yesterday,
            };
        case TimeFrameType.Last7Days:
            return {
                from: yesterday.subtract({ days: 7 }),
                until: yesterday,
            };
        case TimeFrameType.LastWeek:
            return {
                from: lastWeek.subtract({ days: lastWeek.dayOfWeek - 1 }),
                until: lastWeek.add({ days: 7 - lastWeek.dayOfWeek }),
            };
        case TimeFrameType.ThisMonth:
            return {
                from: today.with({ day: 1 }),
                until: today.with({ day: lastMonth.daysInMonth }),
            };
        case TimeFrameType.LastMonth:
            return {
                from: lastMonth.with({ day: 1 }),
                until: lastMonth.with({ day: lastMonth.daysInMonth }),
            };
        case TimeFrameType.Last3Months:
            return {
                from: lastMonth.subtract({ months: 3 }).with({ day: 1 }),
                until: lastMonth.with({ day: lastMonth.daysInMonth }),
            };
        case TimeFrameType.LastYear:
            return {
                from: lastYear.with({ day: 1, month: 1 }),
                until: lastYear.with({ day: 31, month: 12 }),
            };
    }
}
//# sourceMappingURL=timeframe-picker.js.map